import slide1 from './slide1.svg'
import slide2 from './slide2.svg'
import slide3 from './slide3.svg'
import slide4 from './slide4.svg'
import slide5 from './slide5.svg'
import slide6 from './slide6.svg'

export default [slide1, slide2, slide3, slide4, slide5, slide6]
